/* Groël · Nueva home — comportamiento compartido por las secciones gnh-*.
   Se inicializa una vez por elemento, así que funciona igual en la web y al
   añadir, mover o editar secciones desde el personalizador. */
(function () {
  if (window.GroelHome) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  document.documentElement.classList.add('gnh--js');

  function once(el, key) {
    if (!el || el.getAttribute('data-gnh-' + key + '-ready')) return false;
    el.setAttribute('data-gnh-' + key + '-ready', '1');
    return true;
  }

  /* ── scroll: cabecera en blanco al bajar + efecto de la banda de cierre ── */
  var ticking = false;
  function frame() {
    var nav = document.querySelector('[data-gnh-nav]');
    var hero = document.querySelector('.gnh-hero');
    if (nav) {
      /* sin banner (resto de páginas): siempre en blanco */
      var limit = (hero ? hero.offsetHeight : 400) * 0.55;
      nav.classList.toggle('is-solid', !hero || window.scrollY > limit);
    }
    if (!reduce) {
      document.querySelectorAll('[data-gnh-close]').forEach(function (sec) {
        var media = sec.querySelector('.gnh-close__media'), img = sec.querySelector('.gnh-close__img');
        var vh = window.innerHeight, r = sec.getBoundingClientRect();
        var p = (vh - r.top) / Math.min(r.height, vh * 0.85); if (p < 0) p = 0; if (p > 1) p = 1;
        if (media) media.style.clipPath = 'inset(' + ((1 - p) * 18).toFixed(2) + '% 0 0 0)';
        if (img) { var off = (r.top + r.height / 2 - vh / 2) / vh; img.style.transform = 'translateY(' + (off * -46).toFixed(1) + 'px)'; }
      });
    }
    ticking = false;
  }
  function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(frame); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ── buscador a pantalla completa ── */
  function initSearch() {
    var sw = document.querySelector('[data-gnh-search]');
    if (!once(sw, 'search')) return;
    var q = sw.querySelector('[data-gnh-q]'), res = sw.querySelector('[data-gnh-results]'), lab = sw.querySelector('[data-gnh-label]'),
      all = sw.querySelector('[data-gnh-all]'), popular = res.innerHTML, base = sw.getAttribute('data-root') || '',
      showPrice = sw.getAttribute('data-price') === '1', tq = null, last = '';
    function openS(e) { if (e) e.preventDefault(); sw.hidden = false; document.documentElement.classList.add('gnh-lock'); setTimeout(function () { q.focus(); }, 50); }
    function closeS() { sw.hidden = true; document.documentElement.classList.remove('gnh-lock'); }
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-gnh-search-open]')) openS(e); });
    sw.querySelector('[data-gnh-search-close]').addEventListener('click', closeS);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sw.hidden) closeS(); });
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render(term, items) {
      if (!term) { res.innerHTML = popular; lab.textContent = lab.getAttribute('data-default'); all.hidden = true; return; }
      all.href = base + '/search?q=' + encodeURIComponent(term) + '&type=product'; all.hidden = !items.length;
      lab.textContent = items.length ? '' : lab.getAttribute('data-none') + ' “' + term + '”';
      res.innerHTML = items.map(function (p) {
        var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=500" alt="' + esc(p.title) + '" loading="lazy">' : '';
        var price = showPrice && p.price ? '<span class="gnh-card__price">' + esc(p.price) + ' €</span>' : '';
        return '<a class="gnh-card" href="' + esc(p.url.split('?')[0]) + '"><span class="gnh-card__img">' + img + '</span><span class="gnh-card__title">' + esc(p.title) + '</span>' + price + '</a>';
      }).join('');
    }
    q.addEventListener('input', function () {
      var term = q.value.trim(); clearTimeout(tq);
      tq = setTimeout(function () {
        if (term === last) return; last = term;
        if (term.length < 2) { render('', []); return; }
        fetch(base + '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (d) { if (q.value.trim() !== term) return; render(term, (d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () {});
      }, 220);
    });
  }

  /* ── altura de la barra fija: hueco superior y posición de los elementos fijos del tema ── */
  function initNavHeight() {
    var nav = document.querySelector('[data-gnh-nav]');
    var bar = nav && nav.querySelector('.gnh-nav__wrap');
    if (!bar || !once(nav, 'height')) return;
    function set() {
      var h = Math.ceil(bar.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--gnh-nav-h', h + 'px');
    }
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(bar);
    else window.addEventListener('resize', set, { passive: true });
  }

  /* ── contador del carrito: el tema y otros scripts cambian solo el número; se oculta con 0 ── */
  function initCartCount() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('.gnh-nav__cart-count').forEach(function (el) {
      if (!once(el, 'count')) return;
      new MutationObserver(function () {
        var n = el.textContent.trim();
        if (el.getAttribute('data-cart-count') !== n) el.setAttribute('data-cart-count', n);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ── menú móvil ── */
  function initMenu() {
    var nav = document.querySelector('[data-gnh-nav]');
    var burger = document.querySelector('[data-gnh-burger]'), drawer = document.querySelector('[data-gnh-drawer]');
    if (!nav || !burger || !drawer || !once(burger, 'menu')) return;
    drawer.hidden = false;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('[data-gnh-acc] .gnh-acc__top').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentNode, open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) { nav.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; }
    });
  }

  /* ── slider del banner ── */
  function initSlider(sl) {
    if (!once(sl, 'slider')) return;
    var slides = sl.querySelectorAll('[data-gnh-slide]');
    if (slides.length < 2) return;
    var dots = sl.querySelectorAll('[data-gnh-dot]'), cur = 0, timer = null, delay = +(sl.getAttribute('data-delay') || 6500);
    function go(i) {
      slides[cur].classList.remove('is-active'); if (dots[cur]) dots[cur].classList.remove('is-active');
      cur = (i + slides.length) % slides.length;
      slides[cur].classList.add('is-active'); if (dots[cur]) dots[cur].classList.add('is-active');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() { stop(); if (!reduce && !window.Shopify.designMode) timer = setInterval(function () { go(cur + 1); }, delay); }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-gnh-dot')); play(); }); });
    sl.addEventListener('mouseenter', stop); sl.addEventListener('mouseleave', play);
    var x0 = null;
    sl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    sl.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(cur + (dx < 0 ? 1 : -1)); play(); } x0 = null;
    }, { passive: true });
    /* en el personalizador: al seleccionar un slide, se muestra */
    sl.addEventListener('shopify:block:select', function (e) {
      slides.forEach(function (s, i) { if (s === e.target || s.contains(e.target)) { go(i); stop(); } });
    });
    play();
  }

  /* ── sectores: el activo en negro y cambio de imagen ── */
  function initSectors(wrap) {
    if (!once(wrap, 'sectors')) return;
    var img = wrap.querySelector('[data-gnh-sector-img]'), items = wrap.querySelectorAll('.gnh-sector');
    function activate(li) {
      items.forEach(function (x) { x.classList.remove('is-active'); });
      li.classList.add('is-active');
      var src = li.getAttribute('data-img');
      if (src && img && img.getAttribute('src') !== src) { img.style.opacity = 0; setTimeout(function () { img.src = src; img.style.opacity = 1; }, 200); }
    }
    items.forEach(function (li) {
      li.addEventListener('mouseenter', function () { activate(li); });
      li.addEventListener('shopify:block:select', function () { activate(li); });
    });
  }

  /* ── pie en acordeón (móvil) ── */
  function initFooter(root) {
    root.querySelectorAll('[data-gnh-foot] h3').forEach(function (h) {
      if (!once(h, 'foot')) return;
      h.addEventListener('click', function () {
        if (!window.matchMedia('(max-width:640px)').matches) return;
        h.parentNode.classList.toggle('is-open');
      });
    });
  }

  /* ── aparición al hacer scroll ── */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  function initReveal(root) {
    root.querySelectorAll('.gnh-reveal').forEach(function (el) {
      if (!once(el, 'reveal')) return;
      if (io && !window.Shopify.designMode) io.observe(el); else el.classList.add('is-in');
    });
  }

  function init(root) {
    root = root || document;
    initSearch(); initMenu(); initNavHeight(); initCartCount();
    root.querySelectorAll('[data-gnh-slider]').forEach(initSlider);
    root.querySelectorAll('[data-gnh-sectors]').forEach(initSectors);
    initFooter(root); initReveal(root); onScroll();
  }

  window.Shopify = window.Shopify || {};
  window.GroelHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
